import { Component, OnInit } from '@angular/core';
import { AbstractWidgetComponent, AppClientConfigurationService, ContextChange, WidgetStyle } from '@sdbn/common';
import { TmcContextService } from './../../../../common/tmc-context.service';
import { YardConfiguration } from '../../../../client/model/yard-configuration';
import { YardPropertiesService } from '../../../../yard-properties.service';
import { Subscription } from 'rxjs';
import { Station } from '../../../../client/model/station';

@Component({
    selector: 'app-transport-registration-target-station-selection',
    templateUrl: './transport-registration-target-station-selection.component.html',
    styleUrls: ['./transport-registration-target-station-selection.component.scss'],
    standalone: false
})
export class TransportRegistrationTargetStationSelectionComponent extends AbstractWidgetComponent implements OnInit {

  private tmcContextSubscription: Subscription;
  private yardConfiguration: YardConfiguration;

  cardSize = 200;

  availableTargetStations = new Array<Station>();

  constructor(
        public cps: AppClientConfigurationService,
        private tmcContextService: TmcContextService,
        public yardPropertiesService: YardPropertiesService) {
      super();
  
      this.tmcContextSubscription = this.tmcContextService.updated.subscribe(next => {
        if (next != null) {
          this.yardConfiguration = next;
          this.availableTargetStations = next.stations.filter((station) => station.useForManualStationSelection === true);
        }
      });
    }

  ngOnInit(): void {
  }


  ngOnDestroy(): void {
    super.ngOnDestroy();
   
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
    
  }

  selectTargetStation(targetStation: Station) {
    this.dashboardContext.setContextValue("targetStation", targetStation.id);
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
